import { inject, Injectable } from '@angular/core';

import { Customer } from '../../../../model/customer.model';
import { RetailCrmAccountUpdateInput } from '../../model/requests/update-account.model';
import { RetailCrmCustomerFieldsRequestModelMapper } from './customer-fields-model.mapper';

@Injectable({
  providedIn: 'root',
})
export class RetailCrmUpdateCustomerRequestBodyMapper {
  private readonly customerFieldModelMapper = inject(RetailCrmCustomerFieldsRequestModelMapper);

  mapUpdateCustomer(customer: Customer): RetailCrmAccountUpdateInput {
    return {
      syncWithESO: customer.inSyncWithDirectSales,
      privateAddressStreet: customer.privateContact.address?.street,
      privateAddressStreetNumber: customer.privateContact.address?.houseNumber,
      privateAddressPostalCode: customer.privateContact.address?.postalCode,
      privateAddressCity: customer.privateContact.address?.city,
      privateAddressCountry: customer.privateContact.address?.country,
      privateAddressComplement: customer.privateContact.address?.addressLine1,
      privateAddressLine2: customer.privateContact.address?.addressLine2,
      businessAddressStreet: customer.businessContact.address?.street,
      businessAddressStreetNumber: customer.businessContact.address?.houseNumber,
      businessAddressPostalCode: customer.businessContact.address?.postalCode,
      businessAddressCity: customer.businessContact.address?.city,
      businessAddressCountry: customer.businessContact.address?.country,
      businessAddressComplement: customer.businessContact.address?.addressLine1,
      businessAddressLine2: customer.businessContact.address?.addressLine2,
      businessAddressPostBox: customer.businessContact.address?.postBox,
      privateAddressState: customer.privateContact.address?.province,
      businessAddressState: customer.businessContact.address?.province,
      salutation: this.customerFieldModelMapper.mapToRetailCrmSalutation(customer.salutation),
      title: this.customerFieldModelMapper.mapToRetailCrmTitleForWrite(customer.title),
      personEmail: customer.privateContact.email,
      emailBusiness: customer.businessContact.email,
      phone: customer.privateContact.phone,
      personMobilePhone: customer.privateContact.mobile,
      phoneBusiness: customer.businessContact.phone,
      mobilePhoneBusiness: customer.businessContact.mobile,
      privacyConsent: this.customerFieldModelMapper.mapPrivacyConsent(customer.dealerConsent),
      nationalId1: customer.nationalId1,
      nationalId1DocumentType: this.customerFieldModelMapper.mapToNationalIdDocumentTypeForWrite(
        customer.nationalId1DocumentType,
      ),
      taxNumber: customer.taxNumber,
      // Never send an empty language: it would overwrite the value stored in Retail CRM,
      // which applies its own logic when the field is absent.
      correspondenceLanguage: customer.correspondenceLanguage?.trim().toLowerCase() || undefined,
    };
  }
}
